import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../../context/CartContext";

const CartRight = () => {
  const { cart } = useContext(CartContext);
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("token");

  const subtotal = cart.reduce((acc, item) => acc + item.price * item.quantity, 0);

  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [finalPrice, setFinalPrice] = useState(subtotal);
  const [couponMessage, setCouponMessage] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);

  // Automatically update final price if coupon is not applied
  useEffect(() => {
    if (!couponApplied) {
      setFinalPrice(subtotal);
    }
  }, [subtotal, couponApplied]);

  // Automatically reapply coupon on cart subtotal change
  useEffect(() => {
    const reapplyCoupon = async () => {
      if (!couponApplied || !couponCode) return;

      try {
        const response = await fetch("https://app.endorselearning.co.uk/api/apply-coupon", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            code: couponCode,
            course_price: subtotal,
          }),
        });

        const data = await response.json();

        if (data.success) {
          const newFinalPrice = parseFloat(data.final_price.toFixed(2));
          const appliedDiscount = parseFloat((subtotal - newFinalPrice).toFixed(2));

          setDiscount(appliedDiscount);
          setFinalPrice(newFinalPrice);
          setCouponMessage(
            appliedDiscount > 0 ? "Coupon reapplied based on updated cart." : "Coupon reapplied, but no discount."
          );
        } else {
          setCouponMessage("Coupon is no longer valid.");
          setDiscount(0);
          setFinalPrice(subtotal);
          setCouponApplied(false);
        }
      } catch (error) {
        console.error("Error reapplying coupon:", error);
      }
    };

    reapplyCoupon();
  }, [subtotal]);

  const handleProceed = () => {
    if (cart.length === 0) {
      alert("Your cart is empty.");
      return;
    }

    if (!isLoggedIn) {
      localStorage.setItem("redirectAfterLogin", window.location.pathname);
      navigate("/login", { state: { from: "/cart" } });
      return;
    }

    localStorage.setItem("appliedCoupon", couponCode);
    localStorage.setItem("couponDiscount", discount);
    localStorage.setItem("finalPrice", finalPrice);

    navigate("/payment");
  };

  const handleApplyCoupon = async () => {
    try {
      const response = await fetch("https://app.endorselearning.co.uk/api/apply-coupon", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          code: couponCode,
          course_price: subtotal,
        }),
      });

      const data = await response.json();

      if (data.success) {
        const newFinalPrice = parseFloat(data.final_price.toFixed(2));
        const appliedDiscount = parseFloat((subtotal - newFinalPrice).toFixed(2));

        setDiscount(appliedDiscount);
        setFinalPrice(newFinalPrice);
        setCouponMessage(
          appliedDiscount > 0 ? "Coupon applied successfully." : "Coupon applied, but no discount."
        );
        setCouponApplied(true);
      } else {
        setCouponMessage("Invalid or expired coupon.");
        setDiscount(0);
        setFinalPrice(subtotal);
        setCouponApplied(false);
      }
    } catch (error) {
      setCouponMessage("Failed to apply coupon. Try again.");
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <div className="cart-right">
      <h5 className="crt-right-title">Cart Total</h5>
      <table className="table table-total">
        <tbody>
          <tr>
            <th>Subtotal</th>
            <td className="text-end">£{subtotal.toFixed(2)}</td>
          </tr>
          <tr>
            <th>VAT</th>
            <td className="text-end">£0.00</td>
          </tr>
          <tr>
            <th>Coupon</th>
            <td className="text-end">
              {couponApplied ? (
                <div style={{ color: "green" }}>{couponMessage}</div>
              ) : (
                <>
                  <input
                    type="text"
                    name="code"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                    placeholder="Enter the coupon code"
                  />
                  <button type="button" onClick={handleApplyCoupon}>
                    Apply
                  </button>
                  {couponMessage && (
                    <div style={{ color: "red", marginTop: "5px" }}>
                      {couponMessage}
                    </div>
                  )}
                </>
              )}
            </td>
          </tr>
          <tr>
            <th>Total</th>
            <td className="text-end">£{finalPrice.toFixed(2)}</td>
          </tr>
        </tbody>
      </table>

      <button
        type="button"
        className="btn btn-green w-100 mt-4"
        onClick={handleProceed}
      >
        Proceed
      </button>
    </div>
  );
};

export default CartRight;
